import { Redirect, Route, Switch, useLocation } from "wouter";
import { AdminShell } from "./ui/Shell";
import { AiModelsScreen } from "./ui/screens/AiModels";
import { AuditLogScreen } from "./ui/screens/AuditLog";
import { CandidateDeckScreen } from "./ui/screens/CandidateDeck";
import { AdminNotFound } from "./ui/screens/NotFound";
import { NotBuiltScreen } from "./ui/screens/NotBuilt";
import { ObservabilityScreen } from "./ui/screens/Observability";
import { PaymentsScreen } from "./ui/screens/Payments";

function NotFoundRoute() {
  const [location] = useLocation();
  return <AdminNotFound path={location} />;
}

export function App() {
  return (
    <AdminShell>
      <Switch>
        <Route path="/candidates">
          <CandidateDeckScreen />
        </Route>
        <Route path="/audit">
          <AuditLogScreen />
        </Route>
        <Route path="/models">
          <AiModelsScreen />
        </Route>
        <Route path="/payments">
          <PaymentsScreen />
        </Route>
        <Route path="/observability">
          <ObservabilityScreen />
        </Route>
        {/* The five per screen "Not built, and why" tables, in one place. */}
        <Route path="/not-built">
          <NotBuiltScreen />
        </Route>
        {/* SIGNING IN LANDS ON `/`. Sending it to the real address keeps the
            URL, the screen and the highlighted nav item agreeing with each
            other; rendering Observability here instead left all three out of
            step. */}
        <Route path="/">
          <Redirect to="/observability" replace />
        </Route>
        <Route>
          <NotFoundRoute />
        </Route>
      </Switch>
    </AdminShell>
  );
}
